import script from "./line-items-table.vue?vue&type=script&setup=true&lang=js"
export * from "./line-items-table.vue?vue&type=script&setup=true&lang=js"

import "./line-items-table.vue?vue&type=style&index=0&id=05d025d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d025d0"]])

export default __exports__